// Copyright © 2026 Phaena Management B.V. All rights reserved.
// Proprietary and confidential. See COPYRIGHT.md in the repository root.

/**
 * Cross-cutting constants for the landing app.
 *
 * READER_URL points at the gated Wren Reader. In prod this is
 * wren.dasc.nl/app/ (one domain, path-routed), which bounces unentitled
 * visitors to the portal login (nginx auth_request). Override via
 * VITE_TA_READER_URL at build time to target a local Reader dev server.
 *
 * PORTAL_URL is where "request access" / sign-in lands.
 */

export const READER_URL: string =
  (import.meta.env.VITE_TA_READER_URL as string | undefined) ??
  "https://wren.dasc.nl/app/"

export const PORTAL_URL: string =
  (import.meta.env.VITE_PORTAL_URL as string | undefined) ??
  "https://portal.dasc.nl/"
